import type {ReactElement} from 'react';
import type {CollapsibleInfoBoxProps} from './collapsible-info-box.types';
import styles from './collapsible-info-box.module.scss';

function getCollapseClassName(isVisible: boolean): string {
  if (isVisible) {
    return `${styles.collapsible} ${styles.open}`;
  }
  return styles.collapsible;
}

export function CollapsibleInfoBox({isVisible, spacingClassName, children}: CollapsibleInfoBoxProps): ReactElement {
  return (
    <div className={getCollapseClassName(isVisible)} inert={!isVisible}>
      <div className={styles.collapsibleInner}>
        <div className={spacingClassName}>{children}</div>
      </div>
    </div>
  );
}
